import {value} from "nft/random.js";

export const randomize = (pt, min, max, degree) => {
    // given a data point
    if (value() < pt / max) {
        // go lower
        return pt - value()*0.75*(pt - min)*degree
    } else {
        // go higher
        return pt + (max - pt)*0.75*degree*value();
    }
};

